import getPageType from 'rum-pagetypes/src';
import { getEventTrackGA } from './helpers/utils/ga';
import Cookies from 'universal-cookie';

function getCurrentCity(){
	const cookies = new Cookies();
	const cityCookie = cookies.get('new_prefer_city') || 'www';
	return cityCookie;
}

function setCurrentCity(cityName) {
	const cookies = new Cookies();
	if (cityName)
		cookies.set('new_prefer_city',cityName);

}

function getCurrentCityId() {
	const cookies = new Cookies();
	const cityCookie = cookies.get('prefer_city_id') || '1';
	return cityCookie;
}

function getJKID() {
	const cookies = new Cookies();
	const jkidCookie = cookies.get('_jk_id') && cookies.get('_jk_id').split('.');
	return jkidCookie && jkidCookie[0];
}

const exampleConfig = [
	{
		route: {
			path: '/NearByAds',
			exact: true
		},
		header: {
			show: false
		},
		pageType: 'NearByAds',
		sticky: false,
		search: {
			show: false
		},
		footer: {
			show: false
		}
	},
	{
		route: { path: '/:category(pets|matrimonial|community|entertainment|events)/:slug([0-9a-zA-z+\-\.]+-[a-zA-Z]+-W0QQAdIdZ[0-9]+)', exact: true },
		pageType: 'vap',
		pPerformance: true,
		header: {
			show: true,
			back: true,
			hamburger: false,
			handleBackClick: (event, history, match) => {
				const { params: { category } } = match;
				const gaEventObject = { category: `${category}_vap_pwa`, action: `${category}_vap_pwa_goback`, label: `${category}_vap_pwa_goback_click` };
				getEventTrackGA(gaEventObject);
				history.goBack();
			}
		},
		sticky: false,
		search: { show: true },
		footer: { show: false },
		qrum: (location, match) => {
			let category = 'NA';
			if (typeof match !== 'undefined') {
				category = match && match.params && match.params.category;
			}
			const city = getCurrentCityId();
			const config = { PTYPE: getPageType('CORE_VAP_MOBILE'), CAT: category, CITY: city, JKID: getJKID() };
			return config;
		}
	},
	{
		route: {
			path: '/post-classifieds-ads:cityName?/:select(select-category\/?)?',
			exact: true
		}, // Refer https://reacttraining.com/react-router/web/api/Route/path-string.
		header: {
			show: false
		},
		pageType: 'PostAd',
		pPerformance: true,
		sticky: false,
		search: {
			show: false
		},
		footer: {
			show: false
		}
	},
	{
		route: { path: ':slug(.*qc[a-z]{2}0s.*)' },
		pageType: 'snb',
		pPerformance: true,
		header: {
			show: true,
			searchCityCallback: (cityId, cityName, g_id, match,prevcity) => {

				let currentLocation = window.location.href;
				let currentCity;
				currentCity = prevcity?prevcity:'www';
				if (cityName === 'all-India' || cityName === 'All India') {
					if (currentCity !== 'www') {
						window.location = currentLocation.replace('+'+currentCity,'');
					}
					else {
						window.location = currentLocation;
					}
				}
				else if (currentCity !== 'www') {
					window.location = currentLocation.replace(currentCity,cityName.toLowerCase());
				}
				else {
					let replacement = '+' + cityName.toLowerCase() + '+';
					let pos = currentLocation.lastIndexOf('+qc');
					window.location = currentLocation.substring(0,pos) + replacement + currentLocation.substring(pos+1);
				}
			}
		},
		sticky: false,
		search: { show: true,
				  searchterm: () => {
				let currentLocation = window.location.href;
				let urlArray = currentLocation.split('+');
				let splitsearch = urlArray[0].split('/');
				let searchterm = splitsearch[splitsearch.length-1];
				if (searchterm) {
					return searchterm;
				}

				return '';

				  }
		 		},
		footer: { show: true },
		qrum: (location, match) => {
			const city = getCurrentCityId();
			const config = { PTYPE: getPageType('CORE_SEARCH_MOBILE'), CITY: city, JKID: getJKID() };
			return config;
		}
	},
	{
		route: { path: ':slug(.*qc[a-z]{2}1b.*)' },
		pageType: 'snb',
		header: {
			show: true,
			searchCityCallback: (cityId, cityName, g_id, match,prevcity) => {
				let currentLocation = window.location.href;
				let currentCity;
				currentCity = prevcity?prevcity:'www';
				if (cityName === 'all-India' || cityName === 'All India') {
					if (currentCity !== 'www') {
						window.location = currentLocation.replace('+'+currentCity,'');
					}
					else {
						window.location = currentLocation;
					}
				}
				else if (currentCity !== 'www') {
					window.location = currentLocation.replace(currentCity,cityName.toLowerCase());
				}
				else {
					let replacement = '+' + cityName.toLowerCase() + '+';
					let pos = currentLocation.lastIndexOf('+qc');
					window.location = currentLocation.substring(0,pos) + replacement + currentLocation.substring(pos+1);
				}
			}
		},
		pPerformance: true,
		qrum: (location, match) => {
			const city = getCurrentCityId();
			const config = { PTYPE: getPageType('CORE_SEARCH_MOBILE'), CITY: city, JKID: getJKID() };
			return config;
		},
		sticky: false,
		footer: { show: true },
		search: { show: true }
	},
	{
		route: { path: ':slug(.*qc[a-z]{2}1s.*)' },
		pageType: 'snb',
		header: {
			show: true,
			searchCityCallback: (cityId, cityName, g_id, match,prevcity) => {

				let currentLocation = window.location.href;
				let currentCity;
				currentCity = prevcity?prevcity:'www';
				if (cityName === 'all-India' || cityName === 'All India') {
					if (currentCity !== 'www') {
						window.location = currentLocation.replace('+'+currentCity,'');
					}
					else {
						window.location = currentLocation;
					}
				}
				else if (currentCity !== 'www') {
					window.location = currentLocation.replace(currentCity,cityName.toLowerCase());
				}
				else {
					let replacement = '+' + cityName.toLowerCase() + '+';
					let pos = currentLocation.lastIndexOf('+qc');
					window.location = currentLocation.substring(0,pos) + replacement + currentLocation.substring(pos+1);
				}
			}
		},
		sticky: false,
		footer: { show: true },
		qrum: (location, match) => {
			const city = getCurrentCityId();
			const config = { PTYPE: getPageType('CORE_SEARCH_MOBILE'), CITY: city, JKID: getJKID() };
			return config;
		},
		search: { show: true,
				  searchterm: () => {
				let currentLocation = window.location.href;
				let urlArray = currentLocation.split('+');
				let splitsearch = urlArray[0].split('/');
				let searchterm = splitsearch[splitsearch.length-1];
				if (searchterm) {
					return searchterm;
				}

				return '';

				  }
		 		}
	},
	{
		route: {
			path: '/PostAd/',
			exact: true
		},
		header: {
			show: false
		},
		pageType: 'PostAdSuccess',
		sticky: false,
		pPerformance: true,
		search: {
			show: false
		},
		footer: {
			show: false
		}
	},
	{
		route: { path: '/MyChats', exact: true},
		header: {
			show: false
		},
		pageType: 'MyChats',
		sticky: true,
		search: {
			show: false
		},
		footer: {
			show: false
		}

	},
	{
		route: {
			path: '/:catName(community|pets|matrimonial|events|entertainment|education-training)/post-classifieds-ads+:cityName?',
			exact: true
		},
		header: {
			show: false
		},
		pPerformance: true,
		pageType: 'PostAd Form',
		sticky: false,
		search: {
			show: false
		},
		footer: {
			show: false
		}
	},
	{
		route: { path: '/:catName(pets|community|events|matrimonial|entertainment)/:cityName?', exact: true },
		pageType: (location, match) => {
			if (typeof match !== 'undefined') {
				const { params: { catName } } = match;
				return `${catName}_hp`;
			}
			return '';
		},
		header: {
			show: true,
			searchCityCallback: (cityId, cityName, g_id, match) => {
				if (cityName === 'all-India' || cityName === 'All India') {
					window.location = `/${match.params.catName}/all%2DIndia`;
				}
				else {
					window.location = `/${match.params.catName}/${cityName.toLowerCase()}`;
				}
			}
		},
		sticky: false,
		search: { show: true },
		footer: { show: true },
		pPerformance: true,
		qrum: (location, match) => {
			let catName = 'NA';
			if (typeof match !== 'undefined') {
				catName = match && match.params && match.params.catName;
			}
			const city = getCurrentCityId();
			const config = { CAT: catName, PTYPE: getPageType('CORE_CHP_MOBILE'), CITY: city, JKID: getJKID() };
			return config;
		}
	},
	{
		route: { path: '/:cityName?', exact: true }, // Refer https://reacttraining.com/react-router/web/api/Route/path-string.
		header: {
			show: true
		},
		pageType: 'home',
		sticky: false,
		search: { show: true },
		footer: { show: true },
		pPerformance: true,
		qrum: (location, match) => {
			const city = getCurrentCityId();
			const config = { PTYPE: getPageType('CORE_HP_MOBILE'), CITY: city, JKID: getJKID() };
			return config;
		}
	}
];

export default exampleConfig;


// WEBPACK FOOTER //
// ../q-core/src/shellConfig.js